module.exports = "//static.hsappstatic.net/cms-free-branding-lib/static-1.172/css/hsCmsFreeBranding.css"